const cleanPhone = (phone) => {
  // add +1 and remove all non digit characters
  return "+1" + phone.replace(/\D/g, "").replace("+1", "")
}
module.exports = cleanPhone
